import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
// slices
import mailReducer from './slices/mail'
import chatReducer from './slices/chat'
import productReducer from './slices/product'
import tokenReducer from './slices/token'
import customTokenReducer from './slices/customizedToken'
import calendarReducer from './slices/calendar'
import kanbanReducer from './slices/kanban'
import promotionReducer from './slices/promotion'
import feedReducer from './slices/feed'
import spaceReducer from './slices/space'
import suggestedPfpReducer from './slices/suggestedPfp'
import cardStackReducer from './slices/cardStack'

// ----------------------------------------------------------------------

const rootPersistConfig = {
	key: 'root',
	storage,
	keyPrefix: 'redux-',
	whitelist: [],
}

const promotionPersistConfig = {
	key: 'promotion',
	storage,
	keyPrefix: 'redux-',
	whitelist: [],
}

const feedPersistConfig = {
	key: 'feed',
	storage,
	keyPrefix: 'redux-',
	whitelist: [],
}

const spacePersistConfig = {
	key: 'space',
	storage,
	keyPrefix: 'redux-',
	whitelist: [],
}

const suggestedPfpPersistConfig = {
	key: 'suggestedPfp',
	storage,
	keyPrefix: 'redux-',
	whitelist: [],
}

const cardStackPersistConfig = {
	key: 'promotion',
	storage,
	keyPrefix: 'redux-',
	whitelist: [],
}

/* const productPersistConfig = {
	key: 'product',
	storage,
	keyPrefix: 'redux-',
	whitelist: ['sortBy', 'checkout'],
} */

/* const tokenPersistConfig = {
	key: 'token',
	storage,
	keyPrefix: 'redux-',
	whitelist: ['sortBy'],
}

const customTokenPersistConfig = {
	key: 'customtoken',
	storage,
	keyPrefix: 'redux-',
	whitelist: ['sortBy'],
} */

const rootReducer = combineReducers({
	mail: mailReducer,
	chat: chatReducer,
	calendar: calendarReducer,
	kanban: kanbanReducer,
	// product: persistReducer(productPersistConfig, productReducer),
	product: productReducer,
	// token: persistReducer(tokenPersistConfig, tokenReducer),
	token: tokenReducer,
	// customToken: persistReducer(customTokenPersistConfig, customTokenReducer),
	customToken: customTokenReducer,
	promotion: persistReducer(promotionPersistConfig, promotionReducer),
	feed: persistReducer(feedPersistConfig, feedReducer),
	space: persistReducer(spacePersistConfig, spaceReducer),
	suggestedPfp: persistReducer(suggestedPfpPersistConfig, suggestedPfpReducer),
	cardStack: persistReducer(cardStackPersistConfig, cardStackReducer),
})

export { rootPersistConfig, rootReducer }
